import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNewsList, resetNewsList } from './newsAndUpdates/store/actions';
import FontResizeWidget from '../components/FontResizeWidget';
import { Loader } from '../components';
import { ACCESSIBILITY_FEATURE_ENABLED } from '../config';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import moment from 'moment';

const NewsAndUpdates = () => {
  const dispatch = useDispatch();
  const newsResult = useSelector((state) => state.newsList);
  

  const [articles, setArticles] = useState([]);
  console.log(articles);

  const cleanHtmlContent = (html) => {
    if (!html) return '';
        const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const decodedText = tempDiv.textContent || tempDiv.innerText || '';
        return decodedText.replace(/\s+/g, ' ').trim();
  };

  const getRelativeDate = (dateString) => {
    if (!dateString) return '';
    
    const articleDate = moment(dateString).startOf('day');
    const today = moment().startOf('day');
    const diffDays = today.diff(articleDate, 'days');

    if (diffDays === 0) {
      return 'today';
    } else if (diffDays === 1) {
      return 'yesterday';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    } else if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return months === 1 ? '1 month ago' : `${months} months ago`;
    } else {
      const years = Math.floor(diffDays / 365);
      return years === 1 ? '1 year ago' : `${years} years ago`;
    }
  };

 
  useEffect(() => {
    dispatch(fetchNewsList());
  }, [dispatch]);

  useEffect(() => {
    if (newsResult.isSuccess && newsResult.data) {
      const articlesData = newsResult.data.success?.data?.articles || [];
      setArticles(articlesData);
      dispatch(resetNewsList());
    } else if (newsResult.isError) {
      setArticles([]);
      console.error('Failed to fetch news:', newsResult.error);
    }
  }, [newsResult]);


  return (
    <>
      <Helmet>
        <title>News and Updates | My Housing Gateway</title>
        <meta property="og:title" content="News and Updates | My Housing Gateway" />
        <meta name="twitter:card" content="News and Updates | My Housing Gateway" />
        <meta description='If you have an issue with your rented property we can help by creating an action plan for you. This will explain the steps you should take in order to resolve your issue.' />
      </Helmet>
      {ACCESSIBILITY_FEATURE_ENABLED && (
        <FontResizeWidget minSize={14} maxSize={32} step={2} defaultSize={16} />
      )}

      {newsResult.isFetching ? (
        <Loader message={"Loading News..."} />
      ) : newsResult.isSuccess && articles.length > 0 ? (
        <>
        <Container className="news-card">
          <div className="page-header">
            <h1 className="page-title">News & Updates</h1>
            {/* <p className="page-subtitle">Convallis aliquet nam morbi id. Sed integer lorem nisi sed.</p> */}
          </div>
         
            <div className="news-list">
              {articles.map((article, index) => {
              const derivedImage = article?.content?.includes('src="') ? article.content.split('src="')[1]?.split('"')[0] : null
              const imageUrl = article?.image || derivedImage;

              // Use the utility function to clean content
              const cleanContent = cleanHtmlContent(article?.content);

              return (
                <div className="news-item" key={index}>
                  <div className="d-flex align-items-start">
                    {imageUrl && (
                      <img
                        src={imageUrl}
                        alt={article.title}
                        title={article.title}
                        className="news-image"
                      />
                    )}
                   
                    <div className="news-content">
                     <div className="news-grid">
                     <div className='newparent-title'>
                      <h3 className="news-title">
                        <Link to={`/news/${article.slug}`} className="news-title-link">
                          {article.title}
                        </Link>
                      </h3>
                      </div>
                      {cleanContent && (
                        
                        <div className="news-excerpt">
                          {parse(cleanContent)}
                        </div>
                        
                      )}
                      <div className="news-meta">
                        <span className="news-date">
                          Posted {getRelativeDate(article.date)}
                        </span>
                        <Link to={`/news/${article.slug}`} className="read-more-link">Read more</Link>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>  
          </Container>
        </>
      ) : (
        <Container className="news-card">
          <div className="page-header">
            <h1 className="page-title">News & Updates</h1>
            <p className="page-subtitle">No records found.</p>
          </div>
        </Container>
      )}
    </>
  );
};

export default NewsAndUpdates;